import { getDashboardData } from '@/api/getData'

export default {
  namespaced: true,

  // 状态数据
  state: {
    dashboardData: null, // 接口数据
    loading: false,
    timer: null
  },

  // 修改状态
  mutations: {
    SET_DATA(state, data) {
      state.dashboardData = data
    },

    SET_LOADING(state, val) {
      state.loading = val
    },

    SET_TIMER(state, timer) {
      state.timer = timer
    }
  },

  // 触发mutations的异步方法
  actions: {
    async fetchData({ commit }) {
      commit('SET_LOADING', true)

      try {
        const res = await getDashboardData()
        if (res.resultCode == 1) {
          commit('SET_DATA', res.resultInfo)
        }
      } catch (error) {
        console.log(error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // 每5分钟调用一次接口
    startFetching({ dispatch, commit, state }) {
      if (state.timer) return // 防止重复启动

      dispatch('fetchData')

      const timer = setInterval(() => {
        dispatch('fetchData')
      }, 5 * 60 * 1000)

      commit('SET_TIMER', timer)
    },

    // 离开大屏时，清除定时器
    stopFetching({ commit, state }) {
      clearInterval(state.timer)
      commit('SET_TIMER', null)
    }
  },

  // 派生状态的计算属性，可以根据state的值计算出新的属性
  getters: {
    loading: state => state.loading,

    // 平台基本信息
    marketInfo: state => state.dashboardData?.market_info || {},

    //近15日收购价格（含date_1ist/buy_amount/buy_num）
    buyPrice: state => state.dashboardData?.buy_price || {},

    //交易明细列表
    orderList: state => state.dashboardData?.order_list || [],

    //商户统计列表
    orderStatList: state => state.dashboardData?.order_stat_list || [],

    //价格指数
    priceIndex: state => state.dashboardData?.price_index || {},

    //价格列表
    priceList: state => state.dashboardData?.price_list || {},

    // 农户总数
    totalNonghu: state => state.dashboardData?.nonghu_num || 0,

    // 乡镇农户数据
    townNonghuData: state => state.dashboardData?.nonghu_list || []
  }
}
